import {alpha, SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const actionsWrapperSx: SxProps<Theme> = {
    marginBottom: theme.spacing(15 / 8),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};

export const searchInputSx: SxProps<Theme> = {
    maxWidth: theme.spacing(200 / 8),
    width: '100%',
    height: '2rem',
    minHeight: '2rem',
    background: theme.palette.background.default,
    // This list keeps its own search rather than the shared one, and so it kept a desktop width and
    // a desktop height on a phone: 200px of fixed box on a row that did not wrap, sitting on top of
    // the export button beside it. Full width, a finger's height, and 16px so iOS stops zooming.
    [theme.breakpoints.down('md')]: {
        maxWidth: 'none',
        height: '44px',
        minHeight: '44px',
        '& .MuiInputBase-input': {
            fontSize: '16px',
        },
    },
    '&.MuiOutlinedInput-root': {
        paddingLeft: theme.spacing(8 / 8),
    },
    '& svg': {
        fill: theme.palette.neutral[400],
    },
    '& .MuiInputBase-input': {
        fontSize: theme.spacing(12 / 8),
        padding: '8px',
        paddingLeft: 0,
        '&:placeholder': {
            color: theme.palette.neutral[400],
        },
    },
};

export const btnText: SxProps<Theme> = {
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
};

export const filterWrapperSx: SxProps<Theme> = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
    pl: 1,
};

export const filterButtonSx: SxProps<Theme> = {
    height: theme.spacing(30 / 8),
    '&.MuiIconButton-root': {
        background: theme.palette.background.default,
        border: `${theme.spacing(1 / 8)} solid ${theme.palette.neutral[200]}`,
        borderRadius: theme.spacing(4 / 8),
    },
};

export const formWrapperSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        maxWidth: theme.spacing(300 / 8),
        width: '100%',
    },
};

export const filterIconActiveSx: SxProps<Theme> = {
    '&.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
        fill: theme.palette.primary.main,
    },
};

export const tableCellSx: SxProps<Theme> = {
    textAlign: 'left',
    width: '100%',
};

export const chargingSessionsSx = {
    status: {
        px: 1,
        py: 0.5,
        fontWeight: 500,
        fontSize: '0.625em',
        borderRadius: theme.spacing(4 / 8),
    },
    statusActive: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primaryColor[50],
    },
    statusCompleted: {
        color: theme.palette.success.main,
        backgroundColor: alpha(theme.palette.success.main, 0.1),
    },
};
/**
 * The toolbar's own rhythm.
 *
 * Everything in a row is 2rem and carries no caption above it, so a wrap only ever adds a line - it
 * never nudges a neighbour half a line out of true. That is what the old `marginTop: 16px` /
 * `marginBottom: -8px` pair was compensating for, and why adding any labelled control shifted the row.
 */
export const toolbarSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    width: '100%',
};

export const toolbarRowSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
};

export const toolbarSpacerSx: SxProps<Theme> = {
    flex: '1 1 0',
    minWidth: theme.spacing(0.5),
};

export const periodSx: SxProps<Theme> = {
    minWidth: theme.spacing(150 / 8),
};
